// useDomainValidation.js
import { useEffect, useState } from "react";

function useDomainValidation(allowedDomains) {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const currentHostname = window.location.hostname;
    const isAllowedDomain = allowedDomains.includes(currentHostname);
    setIsAllowed(isAllowedDomain);
  }, [allowedDomains]);

  return isAllowed;
}

export default useDomainValidation;
